import React, { useState } from "react"
import UploadImage from "./UploadImage"
import { getTranslations } from "@/components/Returns/v1/localization"
import { useTranslation } from "next-i18next"
import styles from "./faultyProducts.module.scss"
import "react-datepicker/dist/react-datepicker.css"
import Button from "@/components/core/Button/Button"
import { useDispatch } from "react-redux"
import { useDropzone } from "react-dropzone"
import { isMobile } from "react-device-detect"
import { uploadImage } from "@/store/features/genericSlice"
import { uniqueId } from "lodash"
import PageLoader from "@/components/core/PageLoader/PageLoader"

const FaultyProducts = ({ handleImages, onNext, status }) => {
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)

  const [imageFiles, setImageFiles] = useState([])
  const [isShow, setIsShow] = useState(true)
  const dispatch = useDispatch()
  const [errors, setErrors] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const handleNext = () => {
    const imagePayload = imageFiles?.map(file => {
      return {
        imageurl: file?.link,
        imagename: file?.name,
      }
    })
    handleImages(imagePayload)
    onNext()
    setIsShow(false)
    setErrors([])
  }

  const onDrag = newFile => {
    setImageFiles([...imageFiles, ...newFile])
  }
  const onDropOff = file => {
    const newList = imageFiles?.filter(l => l?.id !== file?.id)
    setImageFiles([...newList])
  }

  const handleCount = () => {
    setIsShow(true)
  }
  const onDrop = async (acceptedFiles, rejectedFiles) => {
    setIsLoading(true)
    const errList = rejectedFiles[0]?.errors?.map(el => el?.message)
    errList && setErrors(errList)
    if (!errList && errors?.length > 0) setErrors([])
    setErrors([])
    try {
      const newImageList = await Promise.all(
        acceptedFiles?.map(async (f, i) => {
          const res = await dispatch(
            uploadImage({ uplaodData: f, isReturn: true })
          ).unwrap()
          return Object.assign(f, {
            preview: URL.createObjectURL(f),
            comment: "",
            link: res?.path,
            textCount: 0,
            id: uniqueId(),
          })
        })
      )
      onDrag(newImageList)
      setIsLoading(false)
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err)
      setIsLoading(false)
    }

    if (rejectedFiles[0]?.errors[0]?.code === "file-invalid-type") {
      setErrors([staticText?.errorFileType])
    } else if (rejectedFiles?.length > 1) {
      setErrors([staticText?.uploadCountLimit])
    } else if (rejectedFiles[0]?.file?.size > 5e6) {
      setErrors([staticText?.uploadMBLimit])
    }
    if (!rejectedFiles?.length) {
      setIsShow(false)
    }
    setIsLoading(false)
  }
  const validator = file => {
    if (file?.size > 5e6) {
      return {
        message: staticText?.uploadMBLimit,
      }
    }
    switch (file?.type) {
      case "image/jpeg":
      case "image/png":
      case "image/gif":
      case "application/pdf":
        break
      default:
        return {
          message: staticText?.errorFileType,
        }
    }
  }

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/png, image/jpg, image/jpeg, image/gif, application/pdf",
    maxFiles: 1,
    onDrop,
    validator,
  })
  return (
    <div className={styles.faultyDamaged}>
      <PageLoader loading={isLoading} />
      {status === "edit" ? (
        <>
          <div className="faulty-description">{staticText?.description}</div>
          <ul className="faulty-notes">
            <li>
              The damage/faulty product should be clearly visible in image
            </li>
            <li>Upload a clear product package image</li>
            <li>Upload a product bar code image</li>
          </ul>
          <div className="faulty-image-container">
            <div className="faulty-image-list">
              {imageFiles?.map(data => {
                return (
                  <UploadImage
                    imageList={data}
                    onDropOff={onDropOff}
                    errors={errors}
                    isLoading={isLoading}
                  />
                )
              })}
              {isShow && (
                <div
                  className={`upload-image-container`}
                  id="contact-image-preview-container"
                  tabIndex="0"
                  role="presentation"
                >
                  <div className="drag-and-drop-container" {...getRootProps()}>
                    <input {...getInputProps()} />
                    <div className="drag-and-drop-text-large">
                      {staticText?.dragAndDrop}
                    </div>
                    <div className="drag-and-drop-text-small">
                      {staticText?.orText}
                    </div>
                    <div className="drag-and-drop-upload-btn">
                      <Button
                        role="button"
                        tabIndex="-1"
                        className={"gbh-data-layer"}
                        type="ghost"
                        label={staticText?.uploadFileButton}
                        disabled={
                          (imageFiles?.length === 1 && isMobile) || isLoading
                        }
                        useDefaultClass={true}
                      />
                    </div>
                  </div>
                  <div
                    role="region"
                    aria-live="polite"
                    className="aria-messages"
                  >
                    {status}
                  </div>
                  {errors && (
                    <p className="upload-image-container__error-msg">
                      {errors[0]}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
          {imageFiles?.length < 3 && (
            <div className="faultyDamaged-add" onClick={handleCount}>
              <p>{staticText.faultLink}</p>
            </div>
          )}
          <div className="returnitem__nextbutton">
            <Button
              role="button"
              customClass="returnitem__next"
              label={staticText.returnNext}
              onClick={handleNext}
            />
          </div>
        </>
      ) : (
        <p className="returnitem_image_count">
          {imageFiles?.length ? `${imageFiles?.length} Image Uploaded` : null}
        </p>
      )}
    </div>
  )
}

export default FaultyProducts
